import { render, staticRenderFns } from "./JournalTextField.vue?vue&type=template&id=aace03c2&"
import script from "./JournalTextField.vue?vue&type=script&lang=js&"
export * from "./JournalTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports